import { api } from "@/lib/api";

export async function fetchGuides(category = "") {
  const res = await api.get("/public/guides", { params: category ? { category } : {}, timeout: 8000 });
  return res.data || { items: [], hub: null };
}

export async function fetchGuide(slug) {
  const res = await api.get(`/public/guides/${slug}`, { timeout: 8000 });
  return res.data;
}

export async function fetchServices() {
  const res = await api.get("/public/services", { timeout: 8000 });
  return res.data || { items: [] };
}

export async function fetchService(slug) {
  const res = await api.get(`/public/services/${slug}`, { timeout: 8000 });
  return res.data;
}

export async function fetchCapabilities() {
  const res = await api.get("/public/capabilities", { timeout: 8000 });
  return res.data || { stack: [], comparison: [], qa: [], positioning: {} };
}

export function openContactHref(href) {
  if (!href || href === "/#contact" || href === "#contact") return "/#contact";
  return href;
}
